module.exports = __webpack_public_path__ + "img/hpgs-small.a9bfd5dc.png";